"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { useSyncAuth } from "../../polychain/hooks";
import { useSiweAdapter } from "../../providers/SiweProvider/SiweProvider";
import { AccountActions } from "../../stores/accountStore";
export function useLogout() {
  const $ = _c(5);
  const siweAdapter = useSiweAdapter();
  const {
    syncAuth
  } = useSyncAuth();
  let t0;
  if ($[0] !== siweAdapter || $[1] !== syncAuth) {
    t0 = async () => {
      await siweAdapter?.endSession();
      AccountActions.setAuthenticated(false);
      syncAuth();
    };
    $[0] = siweAdapter;
    $[1] = syncAuth;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const logout = t0;
  let t1;
  if ($[3] !== logout) {
    t1 = {
      logout
    };
    $[3] = logout;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}